import { roundAwayFromZero } from "~/utils/round-away-from-zero";

type PickDisplayPairArgs = {
  showPricesInclVat: boolean;
  priceInclVat: number;
  priceExclVat: number;
  listInclVat: number | null;
  listExclVat: number | null;
};

/**
 * Pick the incl or excl side of a price and its strikethrough list price for
 * display. Excl values are rounded to whole minor units so both sides format
 * alike, and the list price is dropped when it lands on the shown price.
 */
export function pickDisplayPair({
  showPricesInclVat,
  priceInclVat,
  priceExclVat,
  listInclVat,
  listExclVat
}: PickDisplayPairArgs): { price: number; list: number | null } {
  const price = showPricesInclVat
    ? priceInclVat
    : roundAwayFromZero(priceExclVat);

  const rawList = showPricesInclVat ? listInclVat : listExclVat;
  let list: number | null = null;
  if (rawList !== null) {
    list = showPricesInclVat ? rawList : roundAwayFromZero(rawList);
  }
  if (list === price) {
    list = null;
  }

  return { price, list };
}
